module.exports = __webpack_public_path__ + "i18n/zh-TW.629f747804cc8c21bb02af6d5c075492.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1864
// module chunks = 0